import { useState, useEffect } from "react";
import axios from "axios";
import { API } from "../config/api";

/**
 * Fetches the current user's director flag from GET /user-role.
 * Returns { isDirector, loading }.
 *
 * Derives the user identity from sessionStorage/localStorage (same
 * fallback chain used by TopNavBar) and sends it via X-Bonsai-User-Id.
 * The backend is authoritative for is_director — no client-side
 * hardcoded director list needed. Soft-fails to false so a failed
 * fetch never grants director access.
 */
export function useDirectorRole() {
  const [loading, setLoading] = useState(true);
  const [isDirector, setIsDirector] = useState(false);

  useEffect(() => {
    const userEmail =
      sessionStorage.getItem("bonsai_user_id") ||
      localStorage.getItem("bonsai_user_id") ||
      "";

    if (!userEmail) {
      setLoading(false);
      return;
    }

    let cancelled = false;
    axios
      .get(`${API}/user-role`, {
        headers: { "X-Bonsai-User-Id": userEmail },
      })
      .then((res) => {
        if (cancelled) return;
        setIsDirector(!!res.data?.is_director);
      })
      .catch(() => {
        if (!cancelled) setIsDirector(false);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return { isDirector, loading };
}
